import type { GridLocaleText } from "@mui/x-data-grid";
import { enUS, svSE } from "@mui/x-data-grid/locales";

const localeTextMap: Record<"en" | "sv", Partial<GridLocaleText>> = {
    en: enUS.components.MuiDataGrid.defaultProps.localeText,
    sv: svSE.components.MuiDataGrid.defaultProps.localeText,
};

export default localeTextMap;
